import View from './view';
export const ApplicationsListItem = View;
